unit Dataset.Plugins;

interface

uses
  SysUtils, DB,

  JS, WEBLib.DBCtrls,

  XData.Web.Dataset,
  XData.Web.JsonDataset,
  XData.Web.Connection,
  XData.Model.Classes,

  Grid.Settings,
  WEBLib.Dialogs, UUtils;

type
  TDatasetPlugin = class;

  TOnLoad = reference to procedure(DatasetPlugin: TDatasetPlugin);

  TDatasetPlugin = class
  strict private
    FPageSize: integer;
    FPageNumber: integer;
    procedure AddPaginationQueryUrl(Dataset: TXDataWebDataSet; APageNumber: Integer;
      APageSize: integer);
    procedure AddExpandQueryUrl(Dataset: TXDataWebDataSet);
    procedure AddFilterQueryUrl(Dataset: TXDataWebDataSet; AGrid: TDBTableControl;
      AFilterText: string);
    procedure AddOrderByQueryUrl(Dataset: TXDataWebDataSet; SortedItems: TSortedItems);
    procedure AdicionarParametroPersonalizado(Dataset: TXDataWebDataSet);
  private
    procedure SetPageSize(const Value: Integer);
    procedure SetPageNumber(const Value: Integer);
    function GetServerRecordCount: Integer;
  private
    // events
    FOnLoad: TOnLoad;
    FOriginalAfterOpen: TDataSetNotifyEvent;
    procedure InternalAfterOpen(ADataset: TDataSet);

    function RemoverCaracteresEspeciais(pTexto : string): string;
    function GetFiltroStringFormatado(pFiltro, pField : string) : string;
  public
    FOrderByPadrao,
    FFilterPadrao,
    FParametroPersonalizado: string;
    FDataset: TXDataWebDataSet;

    constructor Create(ADataset: TXDataWebDataSet; ALoadCallback: TOnLoad);
    procedure LoadDataset(GridSettings: TGridSettings);
    function IsLastPage: Boolean;
    function PreviousPage: Boolean;
    function NextPage: Boolean;
    property PageSize: Integer read FPageSize write SetPageSize;
    property PageNumber: Integer read FPageNumber write SetPageNumber;
    property ServerRecordCount: Integer read GetServerRecordCount;
  end;

implementation

{ TDatasetPlugin }

procedure TDatasetPlugin.AddPaginationQueryUrl(Dataset: TXDataWebDataSet;
  APageNumber: Integer; APageSize: integer);
begin
  if APageSize = 0 then
    Exit;
  Dataset.QueryTop := APageSize;
  Dataset.QuerySkip := (APageNumber - 1) * APageSize;
end;

procedure TDatasetPlugin.AdicionarParametroPersonalizado(
  Dataset: TXDataWebDataSet);
begin
  if FParametroPersonalizado <> '' then
  begin
    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';
    Dataset.QueryString := Dataset.QueryString + FParametroPersonalizado;
  end;
end;

procedure TDatasetPlugin.AddExpandQueryUrl(Dataset: TXDataWebDataSet);
var
  Field: TField;
  I: integer;
  QueryUrl, FieldName, ExpandProp: string;
  ExpandProps, rs: TJSArray;
begin
  ExpandProps := TJSArray.new;
  for I := 0 to Dataset.FieldCount - 1 do
  begin
    Field := Dataset.Fields[I];
    if Field is TXDataWebEntityField then
    begin
      FieldName := Field.FieldName;
      ExpandProp := FieldName;
      if not ExpandProps.includes(ExpandProp) then
        ExpandProps.push(ExpandProp);
    end
    else if Pos('.', Field.FieldName) > 0 then
    begin
      FieldName := Field.FieldName;
      rs := TJSArray(TJSString(FieldName).split('.'));
      rs.pop;
      ExpandProp := rs.join('/');
      if not ExpandProps.includes(ExpandProp) then
        ExpandProps.push(ExpandProp);
    end;
  end;

  QueryUrl := ExpandProps.join(',');

  if QueryUrl <> '' then
  begin
    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';
    Dataset.QueryString := Dataset.QueryString + '$expand=' + QueryUrl;
  end;
end;

procedure TDatasetPlugin.AddFilterQueryUrl(Dataset: TXDataWebDataSet; AGrid: TDBTableControl;
  AFilterText: string);

  function FindPropertyType(AEntityType: TXDataEntityType; AName: string): TXDataType;
  var
    NavProp: TXDataNavigationProperty;
  begin
    if Pos('.', AName) > 0 then
    begin
      NavProp := AEntityType.FindNavigationProperty(TJSString(AName).split('.')[0]);
      Result := FindPropertyType(NavProp.Target, Copy(AName, Pos('.', AName) + 1, Length(AName)));
    end
    else
      Result := AEntityType.FindProperty(AName).PropertyType;
  end;

  function IsNumber(Value: string): Boolean;
  var
    I: Integer;
  begin
    Result := False;

    if Length(Value) > 8 then
      Exit;

    for I := 1 to Length(Value) do
    begin
      Result := (Value[I] in ['0'..'9']);
      if not Result then
        Exit;
    end;
  end;

var
  QueryUrl: string;
  FilterExpressions: TJSArray;
  Model: TXDataModel;
  EntityType: TXDataEntityType;
  DataField: string;
  Field: TField;
  FieldName,
  lFiltroFormatado: string;
  Prop: TXDataProperty;
  PropType: TXDataType;
  I: integer;
  lDataConversao : TDateTime;
begin
  if  (AFilterText = '') and (FFilterPadrao = '') then
    Exit;

  FilterExpressions := TJSArray.new;

  if AFilterText <> '' then
  begin
    Model := Dataset.Connection.Model;
    EntityType := Model.FindEntitySet(Dataset.EntitySetName).EntityType;
    for I := 0 to AGrid.Columns.Count - 1 do
    begin
      DataField := AGrid.Columns[I].DataField;
      if DataField = '' then
        Continue;
      Field := Dataset.FieldByName(DataField);
      if Field = nil then
        Continue;
      if Field.Tag in [1, 3] then
        Continue;
      FieldName := Field.FieldName;
      if Pos('.', FieldName) = 0 then
        Prop := EntityType.FindProperty(FieldName)
      else
        Prop := EntityType.FindNavigationProperty( TJSString(FieldName).split('.')[0] );
      if Prop = nil then
        Continue;
      PropType := FindPropertyType(EntityType, FieldName);
      if PropType = nil then
        Continue;
      case PropType.TypeKind of
        TXTypeKind.xtInt16, TXTypeKind.xtInt32, TXTypeKind.xtInt64,
        TXTypeKind.xtDouble, TXTypeKind.xtCurrency:
        begin
          if IsNumber(AFilterText) then
            FilterExpressions.push(Format('(%s eq %s)',
              [TJSString(FieldName).replace('.', '/'), AFilterText]));
        end;
        TXTypeKind.xtText:
        begin
          if isString(AFilterText) then
          begin
            lFiltroFormatado :=  GetFiltroStringFormatado(AFilterText, FieldName.ToUpper);

            lFiltroFormatado := RemoverCaracteresEspeciais(lFiltroFormatado);

            if not lFiltroFormatado.IsEmpty then
            begin
              FilterExpressions.push(Format('(contains(%s, ''%s''))',
                [ TJSString(FieldName).replace('.', '/') , lFiltroFormatado]));
            end;
          end
        end;
        TXTypeKind.xtDateTime, TXTypeKind.xtDate:
        begin
          if (Length(AFilterText) >= 10) and TryStrToDate(AFilterText, lDataConversao) then
          begin
            FilterExpressions.push(Format('(substring(%s, 1, 10) eq ''%s'')',
              [TJSString(FieldName).replace('.', '/'), FormatDateTime('yyyy-mm-dd', lDataConversao)]));
          end;
        end;
      end;
    end;
  end;

  if (FilterExpressions.Length > 0) or (FFilterPadrao <> '') then
  begin
    if FFilterPadrao <> '' then
    begin
      QueryUrl := '$filter=('+ FFilterPadrao + ')';

      if (FilterExpressions.Length > 0) then
        QueryUrl := QueryUrl + ' and (' + FilterExpressions.join(' or ') + ')';
    end
    else
      QueryUrl := '$filter=(' + FilterExpressions.join(' or ') + ')';

    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';
    Dataset.QueryString := Dataset.QueryString + QueryUrl;
  end;
end;

procedure TDatasetPlugin.AddOrderByQueryUrl(Dataset: TXDataWebDataSet; SortedItems: TSortedItems);
var
  I: integer;
  QueryUrl: string;
  OrderInfo: TOrderInfo;
  OrderProps: array of string;
begin
  SetLength(OrderProps, Length(SortedItems));
  for I := 0 to Length(SortedItems) - 1 do
  begin
    OrderInfo := SortedItems[I];
    if OrderInfo.Ascending then
      OrderProps[I] := OrderInfo.FieldName + ' asc'
    else
      OrderProps[I] := OrderInfo.FieldName + ' desc';

    FOrderByPadrao := '';

    OrderProps[I] := StringReplace(OrderProps[I], '.', '/', [rfReplaceAll]);
  end;

  if FOrderByPadrao <> '' then
    QueryUrl := FOrderByPadrao;

  if (TJSArray(OrderProps).flength > 0) then
    QueryUrl := QueryUrl + ',' +  TJSArray(OrderProps).join(',');

  if QueryUrl <> '' then
  begin
    if (QueryUrl[Length(QueryUrl)] = ',') then
      Delete(QueryUrl, Length(QueryUrl), 1);

    if (QueryUrl[1] = ',') then
      Delete(QueryUrl, 1, 1);

    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';

    Dataset.QueryString := Dataset.QueryString + '$orderby=' + QueryUrl;
  end;
end;

constructor TDatasetPlugin.Create(ADataset: TXDataWebDataSet;
  ALoadCallback: TOnLoad);
begin
  FDataset := ADataset;
  FDataset.ServerRecordCountMode := TServerRecordCountMode.smNone;
  FPageSize := 0;
  FPageNumber := 0;

  FOnLoad := ALoadCallback;
  FOriginalAfterOpen := FDataset.AfterOpen;
  FDataset.AfterOpen := InternalAfterOpen;
end;

function TDatasetPlugin.GetFiltroStringFormatado(pFiltro,
  pField: string): string;
const
  cFieldsSomenteNumero : array[0..3] of String = ('CNPJ', 'TELEFONE', 'CEP', 'NUMERO');
var
  lIndice : Integer;
begin
  Result := pFiltro;

  for lIndice := Low(cFieldsSomenteNumero) to High(cFieldsSomenteNumero) do
  begin
    if Pos(cFieldsSomenteNumero[lIndice], pField) > 0 then
    begin
      Result := TUtils.SomenteNumeros(pFiltro);
      Break;
    end;
  end;
end;

function TDatasetPlugin.GetServerRecordCount: Integer;
begin
  Result := FDataset.ServerRecordCount;
end;

procedure TDatasetPlugin.InternalAfterOpen(ADataset: TDataSet);
begin
  try
    if Assigned(FOnLoad) then
      FOnLoad(Self);
    if Assigned(FOriginalAfterOpen) then
      FOriginalAfterOpen(ADataset);
  finally
    FDataset.EnableControls;
  end;
end;

function TDatasetPlugin.IsLastPage: Boolean;
begin
  if PageSize = 0 then
    Result := True
  else
    Result := ( PageNumber * PageSize ) >= FDataset.ServerRecordCount;
end;

procedure TDatasetPlugin.LoadDataset(GridSettings: TGridSettings);
begin
  FDataset.DisableControls;
  FDataset.QueryString := '';
  try
    FDataSet.Close;

    AddFilterQueryUrl(FDataSet, GridSettings.Grid, GridSettings.FilterText);
    AddPaginationQueryUrl(FDataSet, PageNumber, PageSize);
    AddExpandQueryUrl(FDataSet);
    AddOrderByQueryUrl(FDataSet, GridSettings.SortedItems);
    AdicionarParametroPersonalizado(FDataSet);
    FDataSet.QueryString := StringReplace(FDataSet.QueryString, '.', '/', [rfReplaceAll, rfIgnoreCase]);
    FDataSet.Load;
  except
    FDataset.EnableControls;
    raise;
  end;
end;

function TDatasetPlugin.NextPage: Boolean;
begin
  Result := not IsLastPage;
  if Result then
    FPageNumber := FPageNumber + 1;
end;

function TDatasetPlugin.PreviousPage: Boolean;
begin
  Result := False;
  if FPageNumber > 1 then
  begin
    FPageNumber := FPageNumber - 1;
    Result := True;
  end;
end;

function TDatasetPlugin.RemoverCaracteresEspeciais(pTexto: string): string;
const
  CaracteresInvalidos: array[0..2] of Char = ('#', '&', '''');
var
  lIndice: Integer;
begin
  Result := pTexto;
  for lIndice := Low(CaracteresInvalidos) to High(CaracteresInvalidos) do
    Result := StringReplace(Result, CaracteresInvalidos[lIndice], '', [rfReplaceAll]);
end;

procedure TDatasetPlugin.SetPageNumber(const Value: Integer);
begin
  FPageNumber := Value;
  if FPageNumber > 0 then
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smInlineCount
  else
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smNone;
end;

procedure TDatasetPlugin.SetPageSize(const Value: Integer);
begin
  FPageSize := Value;
  if FPageSize > 0 then
  begin
    FPageNumber := 1;
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smInlineCount;
  end
  else
  begin
    FPageNumber := 0;
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smNone;
  end;
end;

end.
